export const fullImage = `https://demoimg.miro.io/full/`
export const thumbnailImage = `https://demoimg.miro.io/120_`



// WEBPACK FOOTER //
// ./src/images.config.inc.js